import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-modal',
  standalone: true,
  imports: [ CommonModule ],
  templateUrl: './loading-modal.component.html',
  styleUrls: ['./loading-modal.component.scss'],
})
export class LoadingModalComponent  implements OnInit {
  public isVisible: boolean = false;

  constructor() { }

  ngOnInit() {}


  public activeLoading(){
    this.isVisible = true;
  }

  public inactiveLoading(){
    this.isVisible = false;
  }
}
